import React, { useEffect, useRef } from 'react'

export default function EffectsToggle({ setEnabled, enabled }) {
  const wrapperRef = useRef()
  const textRef = useRef()

  useEffect(() => {
   
    // Create an event handler that will be executed when the window is loaded
    const onWindowLoad = () => {
      // Create a new script element for script1
      const script1 = document.createElement("script");
      script1.src = "https://tympanus.net/codrops/adpacks/analytics.js";
      script1.async = true;

      // Create a new script element for script2
      const script2 = document.createElement("script");
      script2.src = "https://tympanus.net/codrops/adpacks/cda_sponsor.js";
      script2.async = true;

      // Append script1 to the head and script2 to the body
      document.head.appendChild(script1);
      document.body.appendChild(script2);
    };

    // Add the event listener to execute the script-loading code on window load
    window.addEventListener('load', onWindowLoad);


    const observer = new IntersectionObserver(([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1), { threshold: [1] })
    observer.observe(wrapperRef.current)
    
    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <>
      <div ref={wrapperRef} className="EffectsToggle">
        <div className="EffectsToggle__Inner">
          <span ref={textRef} className="EffectsToggle__Text">
            WebGL Scroll Effects
          </span>
          <button onClick={() => setEnabled(!enabled)}>{enabled ? 'ON' : 'OFF'}</button>
        </div>
      </div>
    </>
  )
}
